import { Decimal } from 'decimal.js';
import { decimalMax } from '@/lib/codecimal.js';
import { Societe } from "@/models/model.js";
import * as menu from "@/models/menu.js";
import * as client from "@/models/client.js";

//+ -> commande
export const empty = () => {
  return {
    menus: [],
    client: client.empty(),
    date: new Date(),
    societe: Societe,
    payee: false,
    rabais: 0
  };
};

//+ commande -> { number, number }
export function price(c) {
  let total = menu.priceN(c.menus);
  let apayer = decimalMax(new Decimal(0),
                          new Decimal(total)
                          .sub(new Decimal(c.rabais))).toNumber();
  return { total, apayer };
}

//+ date -> [str, str, str]
function hms(date) {
    return [
        date.getHours().toString().padStart(2,'0'),
        date.getMinutes().toString().padStart(2,'0'),
        date.getSeconds().toString().padStart(2,'0')
    ];
}

export function indexedReversed (menus) {
    let ir = menus.map((e,i) => [e,i+1]);
    ir.reverse();
    return ir;
}

//+ date -> str
export function uid(date) {
  return "BB" + hms(date).join("");
}

//+ commande -> boolean
export function valid(commande) {
    let menusp = commande.menus.length > 0
        && commande.menus.map(menu.valid)
        .reduce((a,b) => a && b, true)

    let clientp = client.valid(commande.client)
    return menusp && clientp
}
